module.exports = __webpack_public_path__ + "img/2228.ff8ae884.png";